module.exports = __webpack_public_path__ + "img/magic_air_sculpting.92bef141.png";